"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { CarePlusInquiryFormData } from "./carePlusInquiry.schema";

import { cn } from "@homeinstead/ui";
import { PhoneInput } from "@homeinstead/ui/components/PhoneInput";
import { useFormContext } from "react-hook-form";
import {
  InquiryStepHeading,
  InquirySubmitButton,
  InquiryTextField,
  inquiryFormErrorTextClass,
  inquiryTextColorClass,
  useInquiryFieldError,
} from "~www/components/LeadForm/Inquiry";

type CarePlusContactStepProps = {
  isPending: boolean;
  textColor?: TextColor;
};

function CarePlusContactStep({
  isPending,
  textColor,
}: CarePlusContactStepProps) {
  const { register } = useFormContext<CarePlusInquiryFormData>();
  const { errors, shouldShowError } =
    useInquiryFieldError<CarePlusInquiryFormData>();
  const errorColorClass = inquiryFormErrorTextClass(textColor);
  const textColorClass = inquiryTextColorClass(textColor);

  return (
    <div className="flex w-full max-w-[440px] flex-col gap-4">
      <InquiryStepHeading textColor={textColor}>
        We will let you know when Care+ is Available
      </InquiryStepHeading>
      <p className={cn("font-bold text-base", textColorClass)}>
        Please fill in your contact details and one of our Care Consultants will
        reach out to you shortly.
      </p>

      <div className="mb-2 flex flex-col gap-6">
        <InquiryTextField
          error={errors.firstName}
          errorClassName={errorColorClass}
          placeholder="First Name"
          showError={shouldShowError("firstName")}
          type="text"
          {...register("firstName")}
        />
        <InquiryTextField
          error={errors.lastName}
          errorClassName={errorColorClass}
          placeholder="Last Name"
          showError={shouldShowError("lastName")}
          type="text"
          {...register("lastName")}
        />
        <InquiryTextField
          error={errors.email}
          errorClassName={errorColorClass}
          placeholder="Email Address"
          showError={shouldShowError("email")}
          type="email"
          {...register("email")}
        />
        <PhoneInput<CarePlusInquiryFormData>
          className="bg-white text-base text-new-beginnings-base"
          errorClassName={errorColorClass}
          fieldName="phone"
          showErrorAfterSubmit
        />
      </div>

      <InquirySubmitButton isPending={isPending} label="Request Care+" />
    </div>
  );
}

export { CarePlusContactStep };
